import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const temperatureDefinitionMap = new Map();

temperatureDefinitionMap.set(KnowEdmTableData.GeothermalTempDefinitionName, {
  key: KnowEdmTableData.GeothermalTempDefinitionName,
  unit: '',
  label: 'Definition Name',
  tooltip: 'entities_temperatureDefinitionNameTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.DrillFloorTemperature, {
  key: KnowEdmTableData.DrillFloorTemperature,
  unit: defaultUnits.get(QuantitiesTypes.Temperature),
  quantity: QuantitiesTypes.Temperature,
  label: 'Drill Floor Temperature',
  tooltip: 'entities_drillFloorTemperatureTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.SeabedTemperature, {
  key: KnowEdmTableData.SeabedTemperature,
  unit: defaultUnits.get(QuantitiesTypes.Temperature),
  quantity: QuantitiesTypes.Temperature,
  label: 'Seabed Temperature',
  tooltip: 'entities_seabedTemperatureTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.TemperatureGradient, {
  key: KnowEdmTableData.TemperatureGradient,
  unit: defaultUnits.get(QuantitiesTypes.TemperatureGradient),
  quantity: QuantitiesTypes.TemperatureGradient,
  label: 'Temperature gradient',
  tooltip: 'entities_temperatureGradientTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.TemperatureAtTD, {
  key: KnowEdmTableData.TemperatureAtTD,
  unit: defaultUnits.get(QuantitiesTypes.Temperature),
  quantity: QuantitiesTypes.Temperature,
  label: 'Temperature at TD',
  tooltip: 'entities_temperatureAtTDTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.TemperatureAtDepth, {
  key: KnowEdmTableData.TemperatureAtDepth,
  unit: defaultUnits.get(QuantitiesTypes.Temperature),
  quantity: QuantitiesTypes.Temperature,
  label: 'Temperature at depth',
  tooltip: 'entities_temperatureAtDepthTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.DepthTVDTemperatureAtDepth, {
  key: KnowEdmTableData.DepthTVDTemperatureAtDepth,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth TVD of Temperature at depth',
  tooltip: 'entities_depthTVDofTemperatureAtDepthTooltip',
});

temperatureDefinitionMap.set(KnowEdmTableData.ReferenceDepth, {
  key: KnowEdmTableData.ReferenceDepth,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Reference depth',
  tooltip: 'entities_referenceDepthTooltip',
});

export { temperatureDefinitionMap };
